module.exports = __webpack_public_path__ + "img/Recipe-364RunBo.85f3b170.png";